import { runtimeConfig } from '@/lib/runtime-config';

/**
 * Rilevamento ambiente lato client.
 *
 * Dev e produzione usano lo stesso `vite build` (MODE=production per
 * entrambi); cambia solo il file `.env` caricato. L'unico segnale
 * affidabile per distinguere la PRODUZIONE è quindi `VITE_CLIENT_URL`
 * (https://app.previxio.com in prod, https://dev.previxio.com in dev,
 * http://localhost:* in locale), fornito dalla configurazione runtime.
 */
const PRODUCTION_CLIENT_URL = 'https://app.previxio.com';

export const isProductionEnv =
  runtimeConfig.VITE_CLIENT_URL === PRODUCTION_CLIENT_URL;
